'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (onOpenStart, onOpenComplete, onCloseStart, onCloseComplete) {
  return {
    onOpenStart: onOpenStart,
    onOpenComplete: onOpenComplete,
    onCloseStart: onCloseStart,
    onCloseComplete: onCloseComplete
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/dialog/internal/getTransitionProps.js
// module id = 205
// module chunks = 171